import * as enUSAssistant from "./en-US/assistant.json";
import * as enUSCommon from "./en-US/common.json";
import * as enUSCustomPrompts from "./en-US/customPrompts.json";
import * as enUSDocumentTypes from "./en-US/documentTypes.json";
import * as enUSLanding from "./en-US/landing.json";
import * as enUSPolicies from "./en-US/policies.json";
import * as enUSSessions from "./en-US/sessions.json";

const locale = window.__CONFIG__?.locale || "en-US"; // TODO: __CONFIG__ is undefined

const locales = {
  "en-US": {
    assistant: enUSAssistant.default,
    common: enUSCommon.default,
    customPrompts: enUSCustomPrompts,
    documentTypes: enUSDocumentTypes,
    landing: enUSLanding.default,
    policies: enUSPolicies,
    sessions: enUSSessions,
  },
  // Add other locales here as needed
};

export const assistant = () => {
  return locales[locale]?.assistant;
};

export const common = () => {
  return locales[locale]?.common;
};

export const customPrompts = () => {
  return locales[locale]?.customPrompts;
};

export const documentTypes = () => {
  return locales[locale]?.documentTypes;
};

export const landing = () => {
  return locales[locale]?.landing;
};

export const policies = () => {
  return locales[locale]?.policies;
};

export const sessions = () => {
  return locales[locale]?.sessions;
};
